import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        signUpCompleteShowReceipt: false,
        signUpEventId: null,
        isSubmitting: false,
        signUpFailed: false
    },
    mutations: {
        completeSignup(state) {
            state.signUpCompleteShowReceipt = true
        },
        set_signUpEventId(state, eventId) {
            state.signUpEventId = eventId
        },
        set_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        },
        set_signUpFailed(state, signUpFailed) {
            state.signUpFailed = signUpFailed
        }
    },
    actions: {
        signUpToEvent(context, payload) {
            const url = process.env.EVENTSIGNUP
            const method = process.env.FETCHMETHOD
            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method: 'POST',
                body: JSON.stringify(payload)
            }

            context.commit('set_submitting', true)
            context.commit('set_signUpFailed', false)

            globalFetch(url, init)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`${response.status} ${response.statusText}`)
                    }
                    context.commit('completeSignup')
                })
                .catch((err) => {
                    context.commit('set_signUpFailed', true)
                    console.error('Der skete en fejl ved tilmelding', err)
                })
                .finally(() => {
                    context.commit('set_submitting', false)
                })
        }
    }
}
